import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/dream-energy/banner_back.webp";

function Banner() {
  return (
    <section
      className="banner_h100 smartid_banner "
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h1 style={{ color: "#fff" }}>
              Dream Energy Solutions Web Development
            </h1>
            <p style={{ color: "#fff" }}>
              Your one-stop shop for all business energy needs - Ontario's
              energy consulting company.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
